import { render } from "./boyaaChinese.vue?vue&type=template&id=2c27213a&scoped=true"
import script from "./boyaaChinese.vue?vue&type=script&lang=js"
export * from "./boyaaChinese.vue?vue&type=script&lang=js"

import "./boyaaChinese.vue?vue&type=style&index=0&id=2c27213a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c27213a"]])

export default __exports__